export const UNSUBSCRIBE_LINK_TYPE_FIELD = 'unsubscribe_link_type';
export const UNSUBSCRIBE_ACTION_FIELD = 'unsubscribe_action';
export const UNSUBSCRIBE_ACTION_SPECIFIC = 'specific';
export const UNSUBSCRIBE_ACTION_ALL = 'all';
export const UNSUBSCRIBE_LINK_TOKEN_SPECIFIC = 'unsubscribe_link_single';
export const UNSUBSCRIBE_LINK_TOKEN_ALL = 'unsubscribe_link_all';
export const PREFERENCES_LINK_TYPE = 'preferences';
export const LINK_FONT_FIELD = 'link_font';
export const BUTTON_LINK_TO_FIELD = 'link_to';
export const SUBSCRIPTION_LINK_TO = 'subscription';
export const BUTTON_SUBSCRIPTION_TYPE_FIELD = 'subscription_type';
export const BUTTON_SUBSCRIPTION_TYPE_UNSUBSCRIBE = 'unsubscribe_all';
export const FOOTER_TYPE_DEFAULT = 'default';